require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/modal-sidebar/modal-sidebar--bundles.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/modal-sidebar/modal-sidebar--bundles.legacy.js
// module id = 704
// module chunks = 31